import { inject, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Subject, map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DespachoService {
  private http = inject(HttpClient);
  
  public cats =  {
    TIPO_DESPACHO: 'tipo_despacho',
    EMPRESA: 'empresa'
  }

  getCatalogo (tipo_catalogo: string) {
    return this.http.get(environment.catalogos.getCatalogo + tipo_catalogo).pipe(
      map((data:any) => {
        if(data.error) return [{id:0, descripcion:'Error al cargar catalogo'}];
        if(tipo_catalogo == this.cats.TIPO_DESPACHO) return data.tipoDespacho;
        return data;
      })
    );
  }

  consultarTemas (tipo_despacho: number, empresa: string, descripcion: string) {
    return this.http.post(environment.despacho.consultarTemas, {
      'id_tipo_despacho': tipo_despacho,
      'id_empresa': empresa,
      'desc_empresa': descripcion
    });
  }

  agregarTema (oDataTema:any) {
    return this.http.post(environment.despacho.guardarTema, oDataTema);
  }

  notificar (oData: any) {
    const endpoint = `${environment.acuerdos.notificacion}/despacho/${oData.notificacion}`;
    return this.http.post(endpoint, oData);
  }

}
